import { GuaranteeDto } from "api/pricing"
import { LoanConfigWithGuaranteeIdsDto } from "api/borrower"
import { MainBorrowerPricingState } from "../../types"
import {
  getGuaranteesToDeactivate,
  isGuaranteeAvailable
} from "../../../../components/guarantees-card/config/guaranteeDependenciesConfig"

export interface ToggleGuaranteeParams {
  loanId: string
  guarantee: GuaranteeDto
}

export const toggleGuarantee = (
  params: ToggleGuaranteeParams,
  onSearch: (loans: LoanConfigWithGuaranteeIdsDto[]) => void,
  getState: () => MainBorrowerPricingState
): void => {
  const { loanId, guarantee } = params
  const state = getState()
  const { pendingLoanConfigs, guaranteesReferential } = state

  // Les garanties obligatoires ne sont pas modifiables
  if (guarantee.isRequired) return

  const currentPendingLoan = pendingLoanConfigs.find(loan => loan.loanId === loanId)
  if (!currentPendingLoan) return

  const currentGuaranteeIds = currentPendingLoan.guaranteeIds || []
  console.log(currentPendingLoan)
  const isActive = currentGuaranteeIds.includes(guarantee.id)

  let updatedGuaranteeIds: string[]
  let additionalUpdates: Partial<LoanConfigWithGuaranteeIdsDto> = {}

  if (isActive) {
    console.log(isActive)
    // Désactivation : retirer la garantie et toutes ses dépendantes
    const guaranteesToRemove = [
      guarantee.id,
      ...getGuaranteesToDeactivate(guarantee.id, currentGuaranteeIds, guaranteesReferential)
    ]
    updatedGuaranteeIds = currentGuaranteeIds.filter(id => !guaranteesToRemove.includes(id))

    // Réinitialiser les valeurs associées selon la garantie désactivée
    if (guarantee.name === "ITT") {
      additionalUpdates = {
        deductible: undefined,
        isPsyBuyback: undefined,
        isContribExempt: undefined,
        isCapital: undefined
      }
    } else if (guarantee.name === "IPT") {
      additionalUpdates = {
        isCapital: undefined
      }
    }
  } else {
    // Activation : vérifier que les dépendances sont respectées
    if (!isGuaranteeAvailable(guarantee.name, currentGuaranteeIds, guaranteesReferential)) {
      return
    }
    updatedGuaranteeIds = [...currentGuaranteeIds, guarantee.id]

    // Initialiser les valeurs par défaut selon la garantie activée
    if (guarantee.name === "ITT") {
      additionalUpdates = {
        deductible: currentPendingLoan.deductible ?? 90,
        isPsyBuyback: currentPendingLoan.isPsyBuyback ?? true
      }
    } else if (guarantee.name === "IPT") {
      additionalUpdates = {
        isCapital: currentPendingLoan.isCapital ?? false
      }
    }
  }

  const updatedConfigs = pendingLoanConfigs.map(config => {
    if (config.loanId === loanId) {
      return {
        ...config,
        ...additionalUpdates,
        guaranteeIds: updatedGuaranteeIds
      }
    }
    return config
  })

  onSearch(updatedConfigs)
}
